/* OfficeLab · comportamento del tema (nessuna dipendenza esterna) */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var desktop = window.matchMedia('(min-width: 990px)');
  var tablet = window.matchMedia('(min-width: 750px)');

  /* ---------- Avvisi brevi ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---------- Pannelli laterali ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    $$('.drawer.is-open').forEach(function (o) { if (o !== d) closeDrawer(o, true); });
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('.drawer__panel [data-close], .drawer__panel a, .drawer__panel button', d);
    setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer(d, silent) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.OL = window.OL || {};
  window.OL.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var id = opener.getAttribute('data-open');
      // Sulla pagina carrello il link del carrello porta semplicemente alla pagina
      if (id === 'CartDrawer' && document.body.classList.contains('tpl-cart')) return;
      if (document.getElementById(id)) { e.preventDefault(); openDrawer(id); }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var drawer = closer.closest('.drawer');
      if (closer.tagName === 'A') { closeDrawer(drawer, true); return; }
      e.preventDefault();
      closeDrawer(drawer);
      return;
    }
    if (e.target.closest('[data-close-on-click]')) {
      var link = e.target.closest('a');
      var dr = e.target.closest('.drawer');
      if (link && link.hash && link.pathname === location.pathname) closeDrawer(dr, true);
    }
    // Chiude i menu a tendina cliccando fuori
    $$('details[data-dropdown][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.drawer.is-open');
    if (open) { closeDrawer(open); return; }
    $$('details[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); var s = $('summary', d); if (s) s.focus(); });
    var sb = $('#HeaderSearch');
    if (sb && !sb.hidden) toggleSearch(false);
  });

  /* Un solo menu a tendina aperto alla volta; su PC si apre anche al passaggio del mouse */
  $$('details[data-dropdown]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) $$('details[data-dropdown][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
    var li = d.parentElement, t;
    li.addEventListener('mouseenter', function () { if (desktop.matches && window.matchMedia('(hover: hover)').matches) { clearTimeout(t); d.setAttribute('open', ''); } });
    li.addEventListener('mouseleave', function () { if (desktop.matches && window.matchMedia('(hover: hover)').matches) { t = setTimeout(function () { d.removeAttribute('open'); }, 150); } });
  });

  /* ---------- Ricerca ---------- */
  function toggleSearch(force) {
    var bar = $('#HeaderSearch');
    if (!bar) return;
    var show = typeof force === 'boolean' ? force : bar.hidden;
    bar.hidden = !show;
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(show)); });
    if (show) { var i = $('input[type="search"]', bar); if (i) i.focus(); }
  }
  $$('[data-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { toggleSearch(); }); });

  /* ---------- Barra annunci: rotazione solo sul telefono ---------- */
  $$('[data-rotator]').forEach(function (r) {
    var items = $$('.announce__item', r);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (desktop.matches || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(r.getAttribute('data-speed'), 10) || 5000);
  });

  /* ---------- Piè di pagina: colonne aperte da tablet in su ---------- */
  function footerCols() {
    $$('[data-footer-col]').forEach(function (d) { if (tablet.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  }
  footerCols();
  if (tablet.addEventListener) tablet.addEventListener('change', footerCols);

  /* ---------- Carrello ---------- */
  function cartSections() {
    var ids = ['cart-drawer'];
    $$('[data-cart-page]').forEach(function (el) { ids.push(el.getAttribute('data-section')); });
    return ids;
  }
  function renderCart(sections, count) {
    if (!sections) return;
    var drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var fresh = $('.drawer__panel', doc), cur = $('#CartDrawer .drawer__panel');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    $$('[data-cart-page]').forEach(function (el) {
      var html = sections[el.getAttribute('data-section')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-page]', doc);
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
    if (typeof count === 'number') {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = count > 0 ? count : ''; });
      $$('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Carrello, ' + count + ' articoli'); });
    }
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Errore');
        return data;
      });
    });
  }
  function refreshCart(open) {
    return fetch(window.OL.routes.root + '?sections=' + cartSections().join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return fetch(window.OL.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
          renderCart(sections, c.item_count);
          if (open) openDrawer('CartDrawer');
        });
      });
  }
  window.OL.addToCart = function (items) {
    return postJSON(window.OL.routes.cartAdd + '.js', { items: items }).then(function () { return refreshCart(true); });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-line]');
    if (!line) return;
    changeLine(line, parseInt(btn.getAttribute('data-qty-change'), 10));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('[data-line]');
    if (line) changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
  });
  function changeLine(line, qty) {
    var root = line.closest('[data-cart-page]') || $('#CartDrawer .drawer__panel');
    if (root) root.classList.add('is-updating');
    postJSON(window.OL.routes.cartChange + '.js', { line: parseInt(line.getAttribute('data-line'), 10), quantity: qty, sections: cartSections() })
      .then(function (c) { renderCart(c.sections, c.item_count); })
      .catch(function (err) { toast(err.message || 'Non è stato possibile aggiornare il carrello.'); return refreshCart(false); })
      .then(function () {
        var r = $('#CartDrawer .drawer__panel'); if (r) r.classList.remove('is-updating');
        $$('[data-cart-page]').forEach(function (el) { el.classList.remove('is-updating'); });
      });
  }

  /* ---------- Modulo prodotto ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var err = $('[data-form-error]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var id = $('[name="id"]', form).value;
      var qty = parseInt(($('[name="quantity"]', form) || { value: 1 }).value, 10) || 1;
      if (err) err.hidden = true;
      btn.classList.add('is-loading');
      window.OL.addToCart([{ id: Number(id), quantity: qty }])
        .catch(function (ex) {
          if (err) { err.textContent = ex.message || 'Non è stato possibile aggiungere il prodotto al carrello.'; err.hidden = false; }
          else toast(ex.message);
        })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* Pulsanti +/− della quantità nella pagina prodotto */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = $('input', b.closest('.qty'));
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 999;
    var v = (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.min(max, Math.max(min, v));
  });

  /* ---------- Varianti ---------- */
  $$('[data-variants]').forEach(function (script) {
    var root = script.closest('[data-pdp]');
    var variants = JSON.parse(script.textContent);
    var form = $('[data-product-form]', root);
    function selected() { return $$('[data-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function money(cents) { var n = (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); return (script.getAttribute('data-currency') || 'EUR') === 'EUR' ? '€' + n : n + ' ' + script.getAttribute('data-currency'); }
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option]')) return;
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var btns = $$('[data-buy-btn]', root.ownerDocument);
      if (!v) { btns.forEach(function (b) { b.disabled = true; b.textContent = 'Non disponibile'; }); return; }
      $('[name="id"]', form).value = v.id;
      $$('[data-price-now]').forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-price-was]').forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; el.hidden = !(v.compare_at_price > v.price); });
      $$('[data-price-off]').forEach(function (el) { var on = v.compare_at_price > v.price; el.hidden = !on; if (on) el.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; });
      btns.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito'; });
      var stock = $('[data-stock]', root);
      if (stock) {
        var q = v.qty;
        stock.className = 'stock';
        if (!v.available) { stock.classList.add('stock--out'); stock.textContent = 'Esaurito'; }
        else if (v.tracked && q === 1) { stock.classList.add('stock--low'); stock.textContent = 'Ultima unità disponibile'; }
        else if (v.tracked && q > 1 && q <= 3) { stock.classList.add('stock--low'); stock.textContent = 'Ultime ' + q + ' unità disponibili'; }
        else if (v.tracked && q > 3) { stock.textContent = q + ' unità disponibili in magazzino'; }
        else { stock.textContent = 'Disponibile'; }
      }
      var qi = $('[name="quantity"]', form);
      if (qi) qi.max = v.tracked && v.qty > 0 ? v.qty : 999;
      if (v.media) {
        var slide = $('[data-media-id="' + v.media + '"]', root);
        var track = slide && slide.parentNode;
        if (slide && track && track.firstElementChild !== slide) { track.insertBefore(slide, track.firstElementChild); }
        if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
      }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    });
  });

  /* ---------- Galleria scorrevole sul telefono ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('.gallery__track', g);
    var dots = $$('.gallery__dots button', g);
    if (!track || !dots.length) return;
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.setAttribute('aria-current', String(i === j)); });
      });
    }, { passive: true });
  });

  /* ---------- Barra acquisto fissa sul telefono ---------- */
  var sticky = $('[data-sticky-buy]');
  var mainBuy = $('[data-main-buy]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(mainBuy);
    var sb = $('button', sticky);
    if (sb) sb.addEventListener('click', function () { var f = $('[data-product-form]'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); });
  }

  /* ---------- Catalogo: ordinamento e filtri ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  });

  /* ---------- Conteggio animato del cartellino in home ---------- */
  $$('[data-count-up]').forEach(function (el) {
    var target = parseInt(el.getAttribute('data-count-up'), 10) || 0;
    if (!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var start = null, duration = 1400;
    el.textContent = '0';
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
      if (t < 1) requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io2.disconnect(); requestAnimationFrame(step); }
      }, { threshold: 0.4 });
      io2.observe(el);
    } else requestAnimationFrame(step);
  });

  /* Prodotti consigliati caricati dopo la pagina */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.closest('.shopify-section').hidden = true;
    }).catch(function () {});
  });

  window.OL.toast = toast;
})();
